const getAssetTransformations = (sourceWidth) =>
  `c_fill,t_base_params,f_auto,pg_1,dpr_1,w_${sourceWidth}`;

export const getAssetPath = (assetUrl, sourceWidth) => {
  try {
    return new URL(assetUrl).href;
  } catch {
    if (!assetUrl) {
      return "";
    }

    if (sourceWidth) {
      return `${window.ENV?.CDN_DOMESTIKA_URL || ""}/${getAssetTransformations(
        sourceWidth
      )}/${assetUrl}`;
    }

    return `${window.ENV?.CDN_DOMESTIKA_URL || ""}/${assetUrl}`;
  }
};
